module.exports = "https://web-assets.ifttt.com/packs/media/layout/chevron-left-gray-07cf948c.svg";